export enum Authentication {
    UNINITIALIZED = 'UNINITIALIZED',
    INITIATED = 'INITIATED',
    LOGGEDIN = 'LOGGEDIN',
    LOGIN_INITIATED = 'LOGIN_INITIATED',
    LOGGEDOUT = 'LOGGEDOUT',
    LOGOUT_INITIATED = 'LOGOUT_INITIATED',
}
